





















































import { State } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";

import { Mode } from "@/types";
import MfaForm from "@/components/settings/MfaForm.vue";
import SettingsManager from "@/components/SettingsManager.vue";

@Component({
  components: { MfaForm, SettingsManager }
})
export default class SettingsButton extends Vue {
  private tab: "endpoints" | "mfa" = "endpoints";

  private isActive: boolean = false;

  private readonly customized: boolean =
    process.env.VUE_APP_CUSTOM_ENDPOINTS_ENABLED === "1";

  @State("mode")
  private mode!: Mode;

  show() {
    this.isActive = true;
  }

  hide() {
    this.isActive = false;
  }
}
